import { LoginButton } from "../components/auth/LoginButton";

export function LoginPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-6">
      <h1 className="heading-2 mb-2" style={{ color: "var(--color-text)" }}>
        Welcome to LOWI
      </h1>
      <p className="body-regular mb-6" style={{ color: "var(--color-text-350)" }}>
        Sign in to get started.
      </p>
      <LoginButton />
    </div>
  );
}
